import { useEffect } from "react";

import { css } from "@compiled/react";

import { Column } from "./column";
import { AnimationSteps } from "./constants/ui";
import { useAnimatedJiraBoardStore } from "./state";

const boardBodyStyle = css({
    borderRadius: "8px",
    overflowY: "hidden"
});
const columnContainerStyle = css({
    display: "flex",
    gap: "12px"
});

export const BoardBody = () => {
    const [
        { messages, todoCol, inProgressCol, doneCol, animationStep },
        { transitionToInProgress, transitionToDone }
    ] = useAnimatedJiraBoardStore();
    useEffect(() => {
        switch (animationStep) {
            case AnimationSteps.IN_PROG_COL:
                transitionToInProgress();
                break;
            case AnimationSteps.DONE_COL:
                transitionToDone();
                break;
        }
    }, [animationStep]);

    return (
        <div css={boardBodyStyle}>
            <div css={columnContainerStyle}>
                <Column title={messages.toDo} cards={todoCol} />
                <Column title={messages.inProgress} cards={inProgressCol} />
                <Column title={messages.done} cards={doneCol} />
            </div>
        </div>
    );
};
